import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=52485c97&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&lang=ts&"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=52485c97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52485c97",
  null
  
)

export default component.exports